import { noOpErrorHandlers, requestWithAuth } from "../../utils/request";
import { getApiUrl } from "../../helpers/api";
import * as notifications from "../notifications/actions";

const API_URL = getApiUrl();
export const REQUEST_RESULT_EXPORT_DOWNLOAD = "REQUEST_RESULT_EXPORT_DOWNLOAD";
export const REQUEST_RESULT_EXPORT_DOWNLOAD_SUCCESS =
    "REQUEST_RESULT_EXPORT_DOWNLOAD_SUCCESS";
export const REQUEST_RESULT_EXPORT_DOWNLOAD_ERROR =
    "REQUEST_RESULT_EXPORT_DOWNLOAD_SUCCESS_ERROR";

function requestResultExportDownload(wevoId) {
    return {
        type: REQUEST_RESULT_EXPORT_DOWNLOAD,
        wevoId
    };
}

function requestResultExportDownloadSuccess(wevoId) {
    return {
        type: REQUEST_RESULT_EXPORT_DOWNLOAD_SUCCESS,
        wevoId
    };
}

function requestResultExportDownloadError(wevoId, error) {
    return {
        type: REQUEST_RESULT_EXPORT_DOWNLOAD_ERROR,
        wevoId,
        error
    };
}

function notifyError(dispatch, wevoId, err) {
    dispatch(requestResultExportDownloadError(wevoId, err));
    return dispatch(
        notifications.notifyError(
            "Unable to export data for this project. If this problem persists, please contact support."
        )
    );
}

export function downloadResultExport(wevoId) {
    return dispatch => {
        requestResultExportDownload(wevoId);
        return requestWithAuth(
            dispatch,
            http =>
                http.get(`${API_URL}/wevos/${wevoId}/results/export`, {
                    responseType: "blob"
                }),
            noOpErrorHandlers
        )
            .then(response => {
                const filename = response.headers["x-filename"];
                const blob = new Blob([response.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(blob);
                return dispatch(requestResultExportDownloadSuccess(wevoId));
            })
            .catch(err => notifyError(dispatch, wevoId, err));
    };
}



// WEBPACK FOOTER //
// ./src/modules/results-export/actions.js